import {
  CREATE_PLC_SAFETY_EVENT,
  CREATE_PLC_SAFETY_EVENT_SUCCESSFUL,
  CREATE_PLC_SAFETY_EVENT_FAILED,
} from './actionTypes';

export const createPlcSafetyEvent = (event) => ({
  type: CREATE_PLC_SAFETY_EVENT,
  payload: { event },
});

export const createPlcSafetyEventSuccessful = (message) => ({
  type: CREATE_PLC_SAFETY_EVENT_SUCCESSFUL,
  payload: message,
});

export const createPlcSafetyEventFailed = (message) => ({
  type: CREATE_PLC_SAFETY_EVENT_FAILED,
  payload: message,
});
